import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import Select from "react-select";
import { api } from "../../../api/apiService";
import DeleteModal from "../../../components/Modal/DeleteModal";

function Attendance() {
  const role = localStorage.getItem("role");

  const [employees, setEmployees] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [attendanceList, setAttendanceList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModal, setIsModal] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const [status, setStatus] = useState("");
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [attendanceToDelete, setAttendanceToDelete] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    fetchAttendanceData(1, startDate, endDate);
  }, []);

  const fetchAttendanceData = async (
    page = 1,
    startDate = "",
    endDate = "",
    append = false
  ) => {
    if (append) {
      setIsFetchingMore(true);
    } else {
      setIsLoading(true);
    }
    try {
      const queryParams = new URLSearchParams({
        page,
        start_date: startDate,
        end_date: endDate,
        employee_id: employeeId,
      }).toString();

      const response = await api.get(`/admin/attendances?${queryParams}`);
      const records = response.data.data.records.data || [];

      if (append) {
        setAttendanceList((prevList) => {
          const uniqueRecords = records.filter(
            (record) =>
              !prevList.some(
                (existing) => existing.attendance_id === record.attendance_id
              )
          );
          return [...prevList, ...uniqueRecords];
        });
      } else {
        setAttendanceList(records);
      }
      setTotalPages(response.data.data.records.last_page || 1);
    } catch (error) {
      if (error.data && error.data.errors) {
        error.data.errors.forEach((err) => {
          toast.error(err);
        });
      } else {
        toast.error("Failed to fetch attendance data");
      }
    } finally {
      if (append) {
        setIsFetchingMore(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  const handleEmployeeChange = (selectedOption) => {
    setEmployeeId(selectedOption ? selectedOption.value : "");
  };

  const employeeOptions = employees.map((emp) => ({
    value: emp.employee_id,
    label: `${emp.first_name} ${emp.last_name}`,
  }));
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get("/get_employees");
        setEmployees(response.data.data);
      } catch (error) {
        console.error("Error fetching employees:", error);
        toast.error("Failed to fetch employees");
      }
    };

    fetchEmployees();
  }, []);

  const loadMore = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      setIsFetchingMore(true);
      fetchAttendanceData(nextPage, startDate, endDate, true);
    }
  };

  const loadLess = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);
      fetchAttendanceData(prevPage, startDate, endDate, false);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchAttendanceData(1, startDate, endDate);
  };

  const clearSearch = () => {
    setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setEmployeeId("");
    setCurrentPage(1);
    fetchAttendanceData(
      1,
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    );
  };

  // const handlePageChange = (selected) => {
  //     setCurrentPage(selected.selected + 1);
  // };

  const openModal = (attendance) => {
    setSelectedAttendance(attendance);
    setStatus(attendance?.approved === 1 ? "disapprove" : "approve");
    setIsModal(true);
  };

  const handleModalClose = () => {
    setIsModal(false);
    setSelectedAttendance(null);
    setStatus("");
  };

  const attendanceApproved = async (status) => {
    setIsLoading(true);
    try {
      const response = await api.post(
        `/admin/attendance/${selectedAttendance?.attendance_id}?status=${status}`
      );
      fetchAttendanceData(1, startDate, endDate);
      toast.success(response?.data?.message);
    } catch (error) {
      if (error.data && error.data.errors) {
        error.data.errors.forEach((err) => {
          toast.error(err);
        });
      } else {
        toast.error("Failed to approve Attendance");
      }
    } finally {
      setIsLoading(false);
      handleModalClose();
    }
  };
  const openDeleteModal = (shift) => {
    setAttendanceToDelete(shift);
    setDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!attendanceToDelete) return;
    try {
      setDeleteLoader(true);
      await api.delete(
        `/admin/delete-attendance/${attendanceToDelete.attendance_id}`
      );
      setAttendanceList((prev) =>
        prev.filter(
          (attendance) =>
            attendance.attendance_id !== attendanceToDelete.attendance_id
        )
      );
      toast.success("Attendance deleted successfully");
      setDeleteModal(false);
      setCurrentPage(1);
      setIsFetchingMore(false);
      setAttendanceToDelete(null);
    } catch (error) {
      if (error.data && error.data.errors) {
        error.data.errors.forEach((err) => {
          toast.error(err);
        });
      } else {
        toast.error("Error deleting attendance");
      }
    } finally {
      setDeleteLoader(false);
    }
  };

  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : "?";
  };

  const InitialAvatar = ({ name }) => (
    <div
      style={{
        width: "30px",
        height: "30px",
        backgroundColor: "#007bff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      {getInitials(name)}
    </div>
  );

  const exportToCSV = () => {
    if (attendanceList.length === 0) {
      toast.warn("No data available to export");
      return;
    }
    const headers = [
      "Employee",
      "Check Time",
      "Check Type",
      "Shift Name",
      "Shift Time",
      "Status",
    ];

    const rows = attendanceList.map((attendance) => [
      attendance.employee_name || "---",
      `\t${
        attendance?.check_time
          ? moment(attendance.check_time).format("DD-MM-YY hh:mm A")
          : "---"
      }`,
      attendance?.check_type || "---",
      attendance?.shift_name || "---",
      `${
        attendance?.shift_start_time
          ? moment(attendance.shift_start_time, "HH:mm:ss").format("h:mm A")
          : "---"
      } - ${
        attendance?.shift_end_time
          ? moment(attendance.shift_end_time, "HH:mm:ss").format("h:mm A")
          : "---"
      }`,
      attendance?.status || "Unknown",
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `attendance_data_${moment().format("YYYY-MM-DD")}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>
          Attendance Logs
          <i
            className="bi bi-info-circle ms-2"
            style={{ cursor: "pointer", fontSize: "1rem" }}
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            title="View and manage employee attendance records with filters, search, and export options."
          ></i>
        </h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Home</Link>
            </li>
            <li className="breadcrumb-item active">Attendance Logs</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Attendance Management</h5>
                <div className="row g-2 mb-3">
                  <div className="col-md-2">
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={
                        employeeOptions.find(
                          (option) => option.value === employeeId
                        ) || null
                      }
                      onChange={handleEmployeeChange}
                      options={employeeOptions}
                      placeholder="Search employee..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "No options"}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderRadius: "6px",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          whiteSpace: "nowrap",
                        }),
                      }}
                    />
                  </div>
                  <div className="col-md-5">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleSearch}
                      disabled={!startDate || !endDate}
                    >
                      Search
                    </button>
                    <button
                      className="btn btn-secondary me-2"
                      onClick={clearSearch}
                      disabled={!startDate && !endDate}
                    >
                      Clear
                    </button>
                    <button
                      className="btn btn-secondary float-end"
                      onClick={exportToCSV}
                    >
                      Export
                    </button>
                  </div>
                </div>

                {isLoading ? (
                  <div className="text-center mt-3">
                    <Spinner animation="border" variant="primary" />
                    <span className="ms-2">Loading...</span>
                  </div>
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Employee</th>
                            <th>Check Time</th>
                            <th>Check Type</th>
                            <th>Shift Name</th>
                            <th>Shift Time</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {attendanceList.length > 0 ? (
                            attendanceList.map((attendance, index) => (
                              <tr key={attendance.attendance_id || index}>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    {attendance?.profile_picture ? (
                                      <img
                                        src={attendance.profile_picture}
                                        alt={attendance.employee_name}
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    ) : (
                                      <InitialAvatar
                                        name={attendance.employee_name}
                                      />
                                    )}
                                    <span>{attendance.employee_name}</span>
                                  </div>
                                </td>
                                <td>
                                  {attendance?.check_time
                                    ? moment(attendance?.check_time).format(
                                        "DD-MM-YY hh:mm A"
                                      )
                                    : "---"}
                                </td>

                                <td
                                  className={
                                    attendance?.check_type === "Check Out"
                                      ? "text-danger"
                                      : attendance?.check_type === "Check In"
                                      ? "text-success"
                                      : ""
                                  }
                                >
                                  <p style={{ marginBottom: "0", lineHeight: "1" }}>
                                    {attendance?.check_type || "---"}
                                  </p>
                                  <small
                                    className="text-muted"
                                    style={{ fontSize: "9px" }}
                                  >
                                    {attendance?.source || "--"}
                                  </small>
                                </td>

                                <td>{attendance?.shift_name || "---"}</td>
                                <td>
                                  {attendance?.shift_start_time
                                    ? moment(
                                        attendance.shift_start_time,
                                        "HH:mm:ss"
                                      ).format("h:mm A")
                                    : "---"}
                                  -
                                  {attendance?.shift_end_time
                                    ? moment(
                                        attendance.shift_end_time,
                                        "HH:mm:ss"
                                      ).format("h:mm A")
                                    : "---"}
                                </td>
                                <td>
                                  <span
                                    className={`badge ${
                                      attendance?.status === "present"
                                        ? "badge-success"
                                        : attendance?.status === "absent"
                                        ? "badge-danger"
                                        : attendance?.status === "late"
                                        ? "badge-warning"
                                        : attendance?.status === "on_leave"
                                        ? "badge-info"
                                        : attendance?.status === "early-exit"
                                        ? "badge-secondary"
                                        : attendance?.status === "on-time"
                                        ? "badge-primary"
                                        : attendance?.status === "over-time"
                                        ? "badge-dark"
                                        : attendance?.status === "early-arrival"
                                        ? "badge-success"
                                        : attendance?.status === "latecomer"
                                        ? "badge-warning"
                                        : "badge-light text-dark"
                                    }`}
                                  >
                                    {attendance?.status || "Unknown"}
                                  </span>
                                </td>
                                <td>
                                  {role === "admin" && (
                                    <button
                                      className="btn btn-danger btn-sm me-2 mb-1"
                                      onClick={() =>
                                        openDeleteModal(attendance)
                                      }
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Delete Attendance"
                                    >
                                      <i className="bi bi-trash"></i>
                                    </button>
                                  )}
                                  {attendance.approved === 0 ? (
                                    <button
                                      className="btn btn-primary btn-sm mb-1"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Approve Attendance"
                                      onClick={() =>
                                        openModal(attendance, "approve")
                                      }
                                    >
                                      <i className="bi bi-shield-check"></i>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-warning btn-sm"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Disapprove Attendance"
                                      onClick={() =>
                                        openModal(attendance, "disapprove")
                                      }
                                    >
                                      <i className="bi bi-shield-x"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No attendance records found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-flex justify-content-center mt-3 gap-2">
                        {!isFetchingMore && currentPage > 1 && (
                          <button
                            className="btn btn-secondary"
                            onClick={loadLess}
                          >
                            Show Less
                          </button>
                        )}
                        {currentPage < totalPages && (
                          <button
                            className="btn btn-primary"
                            onClick={loadMore}
                            disabled={isFetchingMore}
                          >
                            {isFetchingMore ? "Loading..." : "Load More"}
                          </button>
                        )}
                        {currentPage === totalPages && isFetchingMore && (
                          <button className="btn btn-primary" disabled>
                            Loading...
                          </button>
                        )}
                      </div>
                    </div>
                    {/* {totalPages > 1 && (
                                            <ReactPaginate
                                                previousLabel="Prev"
                                                nextLabel="Next"
                                                breakLabel="..."
                                                pageCount={totalPages}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageChange}
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                disabledClassName="disabled"
                                                forcePage={currentPage - 1}
                                            />
                                        )} */}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {isModal && (
        <div className="modal fade show d-block">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Attendance Approval</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalClose}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to {status}{" "}
                  <strong>{selectedAttendance.employee_name}</strong>{" "}
                  attendance?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalClose}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => attendanceApproved(status)}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onClose={() => setDeleteModal(false)}
          onDelete={handleDelete}
          isLoading={deleteLoader}
          body={
            <>
              Are you sure you want to delete the attendance of employee{" "}
              <strong className="text-capitalize">
                "{attendanceToDelete?.employee_name}"
              </strong>
              ?
            </>
          }
        />
      )}
    </main>
  );
}

export default Attendance;
